export default {
    url: '/edit/:id',
    template: `
        <user-employee-edit
            user="vm.user"
            countries="vm.countries"
            direct-managers="vm.directManagers"
            site-id="vm.siteId"
        />`,
    resolve: {
        user (UserResource, $stateParams) {
            return UserResource.get({ id: $stateParams.id, expand: 'drls,directManagers,userDirectManagers' }).$promise;
        },
        directManagers (UserManagerService) {
            return UserManagerService.queryDirectManagersByPrivileges();
        }
    },
    controller (TokenService, user, countries, directManagers) {
        this.siteId = TokenService.getActiveSiteId();
        this.user = user;
        this.countries = countries;
        this.directManagers = directManagers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/employee/edit/index.js